// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.tandem-paginator-list {\n  border-radius: 0;\n  border-top: 1px solid #001978 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
